import { useQuery } from '@tanstack/react-query';
import { getProductById } from '../api/products';

export function useProductDetail(productId: string, enabled = true) {
  return useQuery({
    queryKey: ['product', productId],
    queryFn: () => getProductById(productId),
    enabled: enabled && !!productId,
    staleTime: 5 * 60 * 1000, // 5 minutes
  });
}
